import { typeRoles } from "../../assets/styles/typeRoles";
export default function themeTypography({ variables, }) {
    const ramp = {
        fontFamily: variables.base_font_family,
        fontSize: parseInt(variables.base_font_size, 10),
        fontWeightRegular: variables.base_font_weight_regular,
        fontWeightMedium: variables.font_weight_medium,
        fontWeightBold: variables.font_weight_semibold,
        h1: typeRoles["title-page"], // 16px page title
        h2: typeRoles["title-card"], // 15px card title
        h3: typeRoles["title-section"], // 14px section title
        h4: typeRoles["title-subsection"],
        h5: typeRoles["title-subsection"],
        h6: typeRoles["title-subsection"],
        subtitle1: {
            ...typeRoles["body-sm"],
            color: "var(--mui-palette-text-secondary)",
        },
        subtitle2: typeRoles.label,
        body1: typeRoles.body, // 14px — global body via CssBaseline
        body2: typeRoles["body-sm"], // 13px secondary body
        button: typeRoles.button,
        caption: typeRoles.caption, // 12px metadata
        overline: typeRoles.overline, // 11px uppercase tracked eyebrow
    };
    return ramp;
}
//# sourceMappingURL=typography.js.map